import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

interface NewCountProps {
  count?: number
  blink?: boolean
  dontGroup?: boolean
  className?: string
}

const NewCount: React.FC<NewCountProps> = ({
  count = 0,
  blink = false,
  className,
  dontGroup
}) => {
  const classes = useStyles()

  const displayCount = React.useMemo(() => {
    let countVal = null

    if (count > 0) {
      if (count >= 10) {
        countVal = '9+'
      } else {
        countVal = count
      }
    }

    if (dontGroup) {
      if (count > 99) {
        countVal = '99+'
      } else {
        countVal = count
      }
    }

    return countVal
  }, [count, dontGroup])

  if (count === 0) {
    return null
  }

  return (
    <div className={clsx(classes.root, blink && classes.blinkRoot, className)}>
      <div>{displayCount}</div>
    </div>
  )
}

export default NewCount
